import React, { Component } from 'react'

import { auth } from './services/firebase'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import PublicRoute from './routes/PublicRoute'
import PrivateRoute from './routes/PrivateRoute'

import Loading from './pages/Loading'
import Home from './pages/Home'
import Signup from './pages/Signup'
import Login from "./pages/Login"
import Chat from "./pages/Chat";


export default class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      authenticated: false
    }
  }

  componentDidMount() {
    auth().onAuthStateChanged(user => {
      this.setState({
        loading: false,
        authenticated: !!user
      })
    })
  }

  render() {
    return this.state.loading === true ? <Loading /> : (
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <PrivateRoute path="/chat" authenticated={this.state.authenticated} component={Chat}></PrivateRoute>
          <PublicRoute path="/signup" authenticated={this.state.authenticated} component={Signup}></PublicRoute>
          <PublicRoute path="/login" authenticated={this.state.authenticated} component={Login}></PublicRoute>
        </Switch>
      </Router>
    )
  }
}
